export enum GradeType {
    percent,
    oneToSix,
    fifteenToZero
}
